import TapToast from './TapToast.vue';
import Vue from 'vue';
const toast_list = [];
export function tapToast(content, duration = 3000) {
  const Component = Vue.extend(TapToast);
  const component = new Component({
    propsData: {
      content,
    },
  });
  component.$mount();
  toast_list.push(component);
  document.body.appendChild(component.$el);
  setTimeout(() => {
    component.close();
  }, duration);
}
export function removeToast() {
  toast_list.forEach((component) => {
    component.$el.remove();
  });
}
